import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalCalendarRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/calendar",
  component: lazyRouteComponent(() => import("./calendar.page.js"), "PortalCalendarPage"),
});
